"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addUserImageUrls;

var _replaceBucketKeysWithUrlsInArray = _interopRequireDefault(require("./replaceBucketKeysWithUrlsInArray"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

async function addUserImageUrls({
  apiClient,
  organisationId,
  dataArray,
  key,
  subKey,
  setNewState
}) {
  if (!dataArray.length) {
    return [];
  }

  try {
    const newData = await (0, _replaceBucketKeysWithUrlsInArray.default)({
      apiClient,
      dataArray,
      substitutedKeys: subKey ? [{
        key,
        subKeys: [subKey]
      }] : [key],
      organisationId
    });

    if (setNewState) {
      setNewState(newData);
    }

    return newData;
  } catch (e) {
    const dataWithVoidImages = dataArray.map(item => ({ ...item,
      [key]: { ...item[key],
        [subKey]: void 0
      }
    }));

    if (setNewState) {
      setNewState(dataWithVoidImages);
    }

    return dataWithVoidImages;
  }
}